module.exports = __webpack_public_path__ + "media/images/full-screen-3a823bb8835f5fd6bdb396f749b6edf3.png";